import PropTypes from 'prop-types'

import { Icon } from '../display/icon'

const LockIcon = ({ label = 'Lock', ...rest }) => {
  return (
    <Icon
      label={label}
      {...rest}
      dangerouslySetGlyph={`<svg data-name="Layer 1" viewBox="0 0 300 300"><path d="M214.5 156.8a5 5 0 0 1-5-5v-47.5a63.2 63.2 0 1 0-126.4 0v47.5a5 5 0 0 1-5 5 5 5 0 0 1-5-5v-47.5a73.2 73.2 0 0 1 146.4 0v47.5a5 5 0 0 1-5 5z" style="fill:#1d1d1b"/><path d="M239.9 152.5a7.3 7.3 0 0 0-2.2-5.6 7.2 7.2 0 0 0-5.5-2.2H61.4a7.2 7.2 0 0 0-5.5 2.2 7.3 7.3 0 0 0-2.2 5.6v93.1a7.4 7.4 0 0 0 7.7 7.7h170.8a7.4 7.4 0 0 0 7.7-7.7z" style="fill:#ef8975"/><path d="M232.2 144.7a7.2 7.2 0 0 1 5.5 2.2 7.3 7.3 0 0 1 2.2 5.6v93.1a7.4 7.4 0 0 1-7.7 7.7H61.4a7.4 7.4 0 0 1-7.7-7.7v-93.1a7.3 7.3 0 0 1 2.2-5.6 7.2 7.2 0 0 1 5.5-2.2h170.8m0-10H61.4a17.5 17.5 0 0 0-12.6 5.1 17.7 17.7 0 0 0-5.1 12.7v93.1a17.5 17.5 0 0 0 5.1 12.6 17.1 17.1 0 0 0 12.6 5.1h170.8a17.4 17.4 0 0 0 17.7-17.7v-93.1a17.4 17.4 0 0 0-17.7-17.8z" style="fill:#1d1d1b"/><path d="M146.8 219.4a5 5 0 0 1-5-5v-32.9a5 5 0 0 1 10 0v32.9a5 5 0 0 1-5 5z" style="fill:#1d1d1b"/></svg>`}
    />
  )
}

LockIcon.propTypes = {
  onClick: PropTypes.func,
  label: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.oneOf(['tiny', 'small', 'medium', 'large'])
}

export { LockIcon }
